var React = require('react');

function ArrowSlider (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.2321 15.5382L15.3469 0.653061L16 0L32 16L16 32L15.3469 31.3469L30.2321 16.4618H7.39584e-07L0 15.5382H30.2321Z","fill":"#263400"}));
}

ArrowSlider.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowSlider;

ArrowSlider.default = ArrowSlider;
